<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="1000"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">
                <v-card flat>
                    <v-card-text>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="4" class="section-wrapper">
                                <v-card flat>
                                    <v-card-text>
                                        <div v-for="(item, index) in notDistributedProperties"
                                            :key="index"
                                        > 
                                            <span>{{ item.titleRu }}</span>
                                            <v-btn
                                                @click="addDistrbProperty(item)"
                                                small
                                                tile
                                                text
                                            >
                                                <v-popover :trigger="'hover'">
                                                    <v-icon left>
                                                        far fa-plus-square
                                                    </v-icon>

                                                    <template slot="popover">
                                                        <template>
                                                            <span class="ribbon-button-submenu-title">Добавить настройку импорта показателя</span>
                                                        </template>
                                                    </template>
                                                </v-popover>
                                            </v-btn>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" sm="12" md="8" class="section-wrapper">
                                
                                <v-tabs
                                    v-model="tab"
                                    background-color="transparent"
                                    slider-size="3"
                                    class="tab-selector-panel"
                                    mobile-breakpoint="0"
                                >
                                    <v-tabs-slider color="#E43958"></v-tabs-slider>
                
                                    <v-tab 
                                        v-for="(item, index) in settings"
                                        :key="index"
                                    >
                                        <template>
                                            Лист {{ index + 1 }}
                                        </template> 
                                        <v-btn
                                            @click="addSheet()"
                                            small
                                            tile
                                            text
                                        >
                                            <v-popover :trigger="'hover'">
                                                <v-icon left>
                                                    far fa-plus-square
                                                </v-icon>

                                                <template slot="popover">
                                                    <template>
                                                        <span class="ribbon-button-submenu-title">Добавить настройку импорта показателя</span>
                                                    </template>
                                                </template>
                                            </v-popover>
                                        </v-btn>
                                    </v-tab>
                
                                </v-tabs>
                
                                <v-tabs-items
                                    v-model="tab"
                                    class="tab-content-panel"
                                >
                                    <v-tab-item 
                                        v-for="(item, index) in settings"
                                        :key="index"
                                    >

                                        <v-card flat>
                                            <v-card-text>
                                                <v-btn
                                                    @click="deleteSheet(index)"
                                                    small
                                                    tile
                                                    text
                                                >
                                                    <v-popover :trigger="'hover'">
                                                        <v-icon left>
                                                            far fa-trash
                                                        </v-icon>
                                                        <template>
                                                            {{ $t('Удалить лист') }}
                                                        </template>

                                                        <template slot="popover">
                                                            <template>
                                                                <span class="ribbon-button-submenu-title">Удалить лист</span>
                                                            </template>
                                                        </template>
                                                    </v-popover>
                                                </v-btn>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Наименоваение листа</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            v-model="item.SheetName"
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            :rules="requiredRule"
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Текст для поиска</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            v-model="item.SearchText"
                                                            hide-details
                                                            outlined
                                                            dense
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Колонка для поиска</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            v-model="item.SearchColumn"
                                                            hide-details
                                                            outlined
                                                            dense
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>

                                        <v-card v-for="prop in item.Properties" :key="prop.PropertyName" flat>
                                            <v-card-text>
                                                <div class="form-box-title title-with-right-part">
                                                    <span>{{ getPropertyTitle(prop.PropertyName) }}</span>
                                                    <v-btn
                                                        @click="deleteDistrbProperty(prop)"
                                                        small
                                                        tile
                                                        text
                                                    >
                                                        <v-popover :trigger="'hover'">
                                                            <v-icon left>
                                                                far fa-trash
                                                            </v-icon>
                                                            <template>
                                                                {{ $t('Удалить') }}
                                                            </template>

                                                            <template slot="popover">
                                                                <template>
                                                                    <span class="ribbon-button-submenu-title">Убрать настройку импорта показателя</span>
                                                                </template>
                                                            </template>
                                                        </v-popover>
                                                    </v-btn>
                                                </div>
                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Текст для поиска</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            v-model="prop.SearchText"
                                                            hide-details
                                                            outlined
                                                            dense
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Колонки</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            :value="getColumns(prop)"
                                                            @input="updateColumns(prop, $event)"
                                                            hide-details
                                                            outlined
                                                            dense
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Ячейки</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            :value="getCells(prop)"
                                                            @input="updateCells(prop, $event)"
                                                            hide-details
                                                            outlined
                                                            dense
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Делитель</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            v-model="prop.Divider"
                                                            hide-details
                                                            outlined
                                                            dense
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="4">
                                                        <label class="f-label">Знаков после запятой</label>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="8">
                                                        <v-text-field
                                                            v-model="prop.Precision"
                                                            hide-details
                                                            outlined
                                                            dense
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>

                                    </v-tab-item>
                                </v-tabs-items>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>  
            </v-card-text>
         
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="red"
                    text
                    depressed
                    @click="del"
                >
                    {{ $t("Удалить") }} 
                </v-btn>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="isOkVisible"
                >
                    {{ $t("Сохранить") }} 
                </v-btn>

                <v-btn
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { httpAPI } from "@/api/httpAPI";
export default {
    name: "ImportSettingsEditDlg",
    data () {
        return {
            title: 'Настройка_импорта_классификатора',
            options: {
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            },
            visible: false,
            loading: false,

            resolve: null,
            reject: null,

            classifierId: null,
            settings: null,
            settingsCheck: false,
            schema: null,
            tab: null
        }
    },
    computed: {
        ...mapGetters({ 
            requiredRule: 'getRequiredRule'
        }),
        notDistributedProperties(){
            return this.schema?.properties.filter(p => !this.settings?.some(s => s.Properties.some(sp => sp.PropertyName == p.id)) ?? true) ?? [];
        },
        isOkVisible() {
			return true;
        }
    },
    methods: {
        async open(id){
            this.schema = null;
            this.settings = null;
            this.classifierId = id;
            let response = await httpAPI({ url: `situation-center/classifiers/get-schema/${this.classifierId}`, method: 'GET'});
            if (response)
                this.schema = response.data;
            response = await httpAPI({ url: `situation-center/import/get-setting/${this.classifierId}`, method: 'GET'});
            if (response)    
                this.settings = response.data;
            this.visible = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        async ok(){
            const errors = this.checkSettings();
            if (errors.length == 0){
                const response = await httpAPI({ url: `situation-center/import/set-setting/${this.classifierId}`, data: this.settings, method: 'POST'});
                if (response)    {
                    this.visible = false;
                    this.resolve({ message: 'Ok' });
                }
            }
            else {
                this.$notify.alert(errors.join('/n'));
            }
        },
        async del(){
            const response = await httpAPI({ url: `situation-center/import/del-setting/${this.classifierId}`, method: 'GET'});
            if (response)    {
                this.visible = false;
                this.resolve({ message: 'Ok' });
            }
        },
        async cancel(){
            this.visible = false;
            this.reject({ message: 'Cancelled' });
        },
        getColumns(prop){
            return prop?.Columns?.join(', ');
        },
        updateColumns(prop, columns){
            prop.Columns = columns.replace(' ').split(',');
        },
        getCells(prop){
            return prop?.Cells?.join(', ');
        },
        updateCells(prop, cells){
            prop.Cells = cells.replace(' ').split(',');
        },
        getPropertyTitle(name){
            return this.schema?.properties?.find(p => p.id == name)?.titleRu ?? name;
        },
        deleteDistrbProperty(prop){
            this.settings.forEach(s => {
                let idx = s.Properties.indexOf(prop);
                if (idx >= 0){
                    s.Properties.splice(idx, 1);
                    return;
                }
            });
        },
        addDistrbProperty(item){
            let prop = {
                PropertyName: item.id,
                Divider: 1,
                Precision: 1
            };
            if (!this.settings || this.settings.length == 0){
                this.settings.push({
                    SheetName: '',
                    SearchText: '',
                    SearchColumn: '',
                    Properties: [prop]
                })
            }
            else {
                this.settings[this.tab].Properties.push(prop);
            }
        },
        addSheet(){
            if (!this.settings)
                this.settings = [];
            this.settings.push({SheetName: '',
                SearchText: '',
                SearchColumn: '',
                Properties: []
            });
        },
        deleteSheet(sheetIdx){
            this.settings.splice(sheetIdx, 1)
        },
        checkSettings() {
            let errors = [];
            if (this.settings?.length == 0 ?? true)
                errors.push('Нет ни одного листа');
            else {
                if (this.settings.some(s => !s.SheetName))
                    errors.push('Не у всех листов указано наименование');
                else {
                    this.settings.forEach(s => errors.push(...this.checkSetting(s)))
                }
            }
            return errors;
        },
        checkSetting(setting){
            let errors = [];
            if (!setting.Properties || setting.Properties.length == 0){
                errors.push(`Лист "${setting.SheetName}": Отсуствуют показатели`); 
            }
            else {
                const validColums = setting.Properties.every(p => p.Columns && p.Columns.length > 0 && p.Columns.every(column => this.isValidExcelColumn(column)));
                const validCells = setting.Properties.every(p => p.Cells && p.Cells.length > 0 && p.Cells.every(cell => this.isValidExcelCell(cell)));
                if (validCells && validColums)
                    errors.push(`Лист "${setting.SheetName}": В показателях нужно указывать чтоөто одно - или колонки или ячейки`);
                else if (validColums){
                    if (!this.isValidExcelColumn(setting.SearchColumn))
                        errors.push(`Лист "${setting.SheetName}": Не верный или отсуствует идентификатор колонки для поиска`);
                    if (setting.SearchText && setting.Properties.some(p => !!p.SearchText?.trim()))
                        errors.push(`Лист "${setting.SheetName}": Текст для поиска нужно указывать или для листа или для показателей. Или не указывать нигде если искать нужно по наименованию региона`);
                    if (typeof setting.SearchText === 'string' && setting.SearchText.length == 0){
                        const allEmpty = setting.Properties.every(obj => !obj.SearchText?.trim());
                        const allNonEmpty = setting.Properties.every(obj => !!obj.SearchText?.trim());
                        if (!(allEmpty || allNonEmpty))
                            errors.push(`Лист "${setting.SheetName}": Текст для поиска нужно указывать (или не указывать) у всех показателей`);
                    }
                }
                else if (validCells) {
                    if (setting.SearchText && setting.Properties.some(p => !!p.SearchText?.trim()))
                        errors.push(`Лист "${setting.SheetName}": Текст для поиска не нужно указывать если для показателей указаны ячейки`);
                }
                else 
                    errors.push(`Лист "${setting.SheetName}": Показатели не заполнены`)
            }
            return errors;
        },
        isValidExcelColumn(col){
            if (!/^[A-Z]{1,3}$/.test(col)) return false;

            // Преобразуем строку в номер столбца
            let number = 0;
            for (let i = 0; i < col.length; i++) {
                number = number * 26 + (col.charCodeAt(i) - 64); // 'A' = 65
            }

            return number >= 1 && number <= 16384;
        },
        isValidExcelCell(cell) {
            const match = /^([A-Z]{1,3})(\d{1,7})$/.exec(cell);
            if (!match) return false;

            const [, col, rowStr] = match;

            const rowNum = parseInt(rowStr, 10);

            return this.isExcelColumn(col) && rowNum >= 1 && rowNum <= 1048576;
        }
    },
}
</script>